<template>
  <b-modal
    id="field-props-modal"
    hide-footer
    hide-header
    centered
    content-class="!rounded-[8px]"
  >
    <b-form
      ref="fieldProps"
      class="sm:px-[12px] py-[8px] sm:py-[20px] min-h-[256px] group"
      @submit="handleSubmit"
    >
      <b-form-group
        label="Label"
        label-for="label"
        class="pb-[8px] [&>label]:text-[14px]"
      >
        <b-form-input
          id="label"
          name="label"
          :value="data.label"
          placeholder="Masukkan label"
        />
      </b-form-group>
      <b-form-group
        label="Placeholder"
        label-for="placeholder"
        class="pb-[8px] [&>label]:text-[14px]"
      >
        <b-form-input
          id="placeholder"
          name="placeholder"
          :value="data.placeholder"
          placeholder="Masukkan placeholder"
        />
      </b-form-group>
      <div
        v-if="data.type === 'number'"
        class="pt-[20px] !border-t border-[#E2E2E2]"
      >
        <b-form-group
          label="Nilai Minimal"
          label-for="min_value"
          class="pb-[8px] [&>label]:text-[14px]"
        >
          <b-form-input
            id="min_value"
            name="min_value"
            type="number"
            inputmode="numeric"
            :value="data.min_value"
          />
        </b-form-group>
        <b-form-group
          label="Nilai Maksimal"
          label-for="max_value"
          class="pb-[8px] [&>label]:text-[14px]"
        >
          <b-form-input
            id="max_value"
            name="max_value"
            type="number"
            inputmode="numeric"
            :value="data.max_value"
          />
        </b-form-group>
      </div>
      <div
        v-if="data.options"
        class="rounded-[8px] p-[16px] !border border-[#E2E2E2] mb-[24px]"
      >
        <span class="text-[#333] text-[14px]">Pilihan</span>
        <div class="flex flex-col items-end w-full gap-[16px] mt-[8px]">
          <draggable
            class="flex flex-col items-end w-full gap-[16px]"
            tag="div"
          >
            <div
              v-for="i in optionsLength"
              :key="i"
              class="flex items-center gap-[12px] w-full"
            >
              <span class="min-w-[25px] h-[25px] rotate-90 !grid place-items-center rounded-[8px] bg-[#F4F4F4] cursor-move">
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
                  alt="drag"
                  width="21"
                  height="21"
                >
              </span>
              <b-form-input
                :id="`option-${i}`"
                name="options"
                :value="data.options[+i - 1] || ''"
              />
            </div>
          </draggable>
          <b-button
            type="button"
            variant="primary"
            class="w-fit font-medium relative overflow-hidden h-[32px] w-[40px] !grid place-items-center"
            @click="optionsLength++"
          >
            <span class="absolute text-[24px]">+</span>
          </b-button>
        </div>
      </div>
      <b-form-checkbox
        id="required"
        name="required"
        class="[&>*]:cursor-pointer"
        :checked="data.required"
      >
        Required?
      </b-form-checkbox>
      <div class="flex gap-[12px] flex-wrap mt-[24px]">
        <b-button
          type="button"
          variant="outline-primary"
          class="grow basis-[100px]"
          @click="$bvModal.hide('field-props-modal')"
        >
          Batal
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          class="grow basis-[100px] group-has-[:placeholder-shown]:!bg-[#F4F4F4] group-has-[:placeholder-shown]:!border-[#E2E2E2]
          group-has-[:placeholder-shown]:!text-[#C2C2C2] group-has-[:placeholder-shown]:pointer-events-none"
        >
          Simpan
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  props: {
    data: {
      type: Object,
      default: () => ({
        type: 'text',
        label: 'Tanggal',
        min_value: 0,
        max_value: 100,
        placeholder: 'Pilih Tanggal',
        options: ['Pilihan 1'],
        required: false,
      }),
    },
  },
  data() {
    return {
      optionsLength: 0,
    }
  },
  watch: {
    data(value) {
      this.optionsLength = value.options ? value.options.length : 0
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      const form = new FormData(this.$refs.fieldProps)
      const newData = Object.fromEntries(form.entries())
      if (!newData.label || !newData.placeholder) return

      const data = { ...this.data, ...newData }
      data.required = Boolean(newData.required)
      data.min_value = data.min_value === '0' ? 0 : (+data.min_value || null)
      data.max_value = data.max_value === '0' ? 0 : (+data.max_value || null)

      if (this.data.options) {
        data.options = form.getAll('options').filter(value => !!value)
        if (!data.options.length) {
          this.$toast_error({ message: 'Dropdown harus memiliki minimal satu opsi' })
          return
        }
      }

      if (data.min_value && data.max_value && data.min_value >= data.max_value) {
        this.$toast_error({ message: 'Nilai minimal harus lebih kecil dari nilai maksimal' })
        return
      }

      this.$emit('save', data)
      this.$bvModal.hide('field-props-modal')
    },
  },
}
</script>
